import { createFileRoute } from "@tanstack/react-router";
import AdminCountriesPage from "@/admin/pages/countries";

export const Route = createFileRoute("/admin/countries/")({
  component: AdminCountriesPage,
});
